import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GetPropertyByString } from '@fi-shared/fi-shared-services/extensions.service';
import { ItemsListRowItemBase } from '../list-row-item-base';

@Component({
    selector: 'fi-items-list-row-item-array-span',
    templateUrl: './array-span.component.html',
    styleUrls: ['./array-span.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemArraySpanComponent extends ItemsListRowItemBase {
    // note: the same as ItemsListRowItemArrayAComponent
    GetToolTip() {
        const result = [],
            items = this.data[this.head.PropertyName];
        for (let i = 0; i < items.length; i++) {
            result.push(GetPropertyByString(items[i], this.head.ChildPropertyName));
        }

        return result.join(', ');
    }
}
